export const SET_GENERATE_PRINT = 'PDV/SET_GENERATE_PRINT';
export const SET_CHECKOUTS = 'PDV/SET_CHECKOUTS';
export const POST_CHECKOUT = 'PDV/POST_CHECKOUT';
export const SET_SAT_TRANSMITTER = 'PDV/SET_SAT_TRANSMITTER';
export const SET_DISCOUNT = 'PDV/SET_DISCOUNT';
export const SET_DISCOUNT_ITEM = 'PDV/SET_DISCOUNT_ITEM';
export const SET_EXTRA_VALUE_ITEM = 'PDV/SET_EXTRA_VALUE_ITEM';
export const SET_EXTRA_VALUE = 'PDV/SET_EXTRA_VALUE';
export const SET_TOTAL = 'PDV/SET_TOTAL';
export const SET_MODAL_DISCOUNT_EXTRA_VALUE_ITEM = 'PDV/SET_MODAL_DISCOUNT_EXTRA_VALUE_ITEM';
export const GET_TOTAL_NOTA = 'PDV/GET_TOTAL_NOTA';
